<template>
  <v-container>
    <div class="mb-5">
      <material-card color="primary" title="Ubah Pengguna" class="card-wrapper">
        <v-form>
          <v-row>
            <div class="form-input mt-5 mb-3">
              <p style="color: red">* Wajib Diisi</p>
            </div>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Username</p>
                <v-text-field 
                  dense
                  placeholder="Username" 
                  required
                  outlined
                  readonly
                  disabled
                  v-model="formData.username"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Nama Lengkap<span style="color: red">*</span></p>
                <v-text-field 
                  dense
                  placeholder="Nama Lengkap"
                  required
                  outlined
                  v-model="formData.nama_lengkap"
                  @input="$v.formData.nama_lengkap.$touch()"
                  @blur="$v.formData.nama_lengkap.$touch()"
                  :error-messages="namalengkapErrors"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">NIK</p>
                <v-text-field 
                  dense
                  placeholder="NIK" 
                  outlined
                  v-model="formData.nik"
                  @input="$v.formData.nik.$touch()"
                  @blur="$v.formData.nik.$touch()"
                  :error-messages="nikErrors"
                />
              </div>
              <p v-if="errorMessageNik" style="color:red;">{{errorMessage}}</p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Jabatan</p>
                <v-text-field 
                  dense
                  placeholder="Jabatan"
                  outlined
                  v-model="formData.jabatan"
                  @input="$v.formData.jabatan.$touch()"
                  @blur="$v.formData.jabatan.$touch()"
                  :error-messages="jabatanErrors"
                />
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Email<span style="color: red">*</span></p>
                <v-text-field 
                  dense
                  placeholder="Email" 
                  required
                  outlined
                  v-model="formData.email"
                  @input="$v.formData.email.$touch()"
                  @blur="$v.formData.email.$touch()"
                  :error-messages="emailErrors"
                />
              </div>
              <p v-if="errorMessageEmail" style="color:red;">{{errorMessage}}</p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                <v-autocomplete
                  no-data-text="Tidak ada data"
                  :items="organisasis"
                  :item-text="item => item.nama"
                  :item-value="item => item.id"
                  placeholder="Pilih Organisasi (PAU/Fakultas/Sekolah)"
                  clearable
                  required
                  dense
                  outlined
                  v-model="formData.organisasi"
                  @input="$v.formData.organisasi.$touch()"
                  @blur="$v.formData.organisasi.$touch()"
                  :error-messages="organisasiErrors"
                  @keydown.enter.prevent
                  >
                </v-autocomplete>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">File Tanda Tangan</p>
                <v-file-input
                  dense
                  v-model="formData.file1"
                  outlined
                  accept=".png"
                  @input="$v.formData.file1.$touch()"
                  @blur="$v.formData.file1.$touch()"
                  hint="File harus berformat PNG"
                  persistent-hint=true
                >
                </v-file-input>
                <a v-if="this.formData.file_ttd !== '' " v-bind:href="filettdimg" v-bind:download="formData.file_ttd"> {{ this.formData.file_ttd }}</a> &nbsp;
                <v-btn v-if="this.formData.file_ttd !== '' " small color="primary" dark @click="showFileTtd()">Lihat Gambar</v-btn>&nbsp;
                <v-btn v-if="this.formData.file_ttd !== ''" small color="red" dark class="mr-4" @click="deleteDialog(`Tanda Tangan`)">Hapus File Tanda Tangan</v-btn>&nbsp;
              </div>
              <p style="color:red;">{{errorMessageTtd}}</p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">File Paraf</p>
                <v-file-input
                  dense
                  v-model="formData.file2"
                  outlined
                  accept=".png"
                  @input="$v.formData.file2.$touch()"
                  @blur="$v.formData.file2.$touch()"
                  hint="File harus berformat PNG"
                  persistent-hint=true
                >
                </v-file-input>
                <a v-if="this.formData.file_paraf !== '' " v-bind:href="fileparafimg" v-bind:download="formData.file_paraf"> {{ this.formData.file_paraf }}</a> &nbsp;
                <v-btn v-if="this.formData.file_paraf !== ''" small color="primary" dark @click="showFileParaf()">Lihat Gambar</v-btn>&nbsp;
                <v-btn v-if="this.formData.file_paraf !== ''" small color="red" dark class="mr-4" @click="deleteDialog(`Paraf`)">Hapus File Paraf</v-btn>&nbsp;
              </div>
              <p style="color:red;">{{errorMessageParaf}}</p>
            </v-col>
            <v-col cols="12" md="6">
              <div class="form-input">
                <p class="label font-weight-bold mb-1">Status</p>
                <v-checkbox v-model="formData.status" v-if="this.formData.status === true" label="Aktif"/> 
                <v-checkbox v-model="formData.status" v-else-if="this.formData.status === false" label="Tidak Aktif"/>
              </div>
            </v-col>
            <v-col cols="12" class="text-right">
              <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp;
              <v-btn color="primary" dark @click="postData()">Simpan</v-btn>&nbsp;
            </v-col>
          </v-row>
        </v-form>
        <v-dialog v-model="dialog" max-height="800px" max-width="800px">
          <v-card class="card-modal" style="box-shadow:none!important;">
            <v-toolbar
              dark
              color="primary"
            >
              <v-toolbar-title>{{ titledialog }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="close()"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <div class="text-center mt-6 mb-6">
              <img v-if="dialogttd" :src="filettdimg" alt="File Tanda Tangan" width="90%">
              <img v-if="dialogparaf" :src="fileparafimg" alt="File Paraf" width="90%">
            </div>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogdel" max-width="500px">
          <v-card class="card-modal">
            <v-card-title>
              <span class="headline">Hapus File {{filedelete}}</span>
            </v-card-title>
  
            <v-card-text>
              Apakah anda yakin ingin menghapus File {{filedelete}} ini?
            </v-card-text>
  
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn @click="close()">Batal</v-btn>
              <v-btn color="primary" dark @click="deleteFile()">Hapus</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="5000" :top="true">
          {{ snackbarText }}
          <v-btn dark text @click="snackbar = false">Tutup</v-btn>
        </v-snackbar>
      </material-card>
    </div>

  </v-container>
</template>

<script>
import { apiServer } from "../../setup-axios";
import { minLength, maxLength, helpers, required } from "vuelidate/lib/validators";

const textregex = helpers.regex('textregex', /^[a-zA-Z0-9 .,'()&\/-]{1,255}$/i);
const emailregex = helpers.regex('emailregex', /^[a-zA-Z0-9._]{2,220}@[a-zA-Z0-9.]{2,25}\.[a-zA-Z]{2,10}$/i);
const nikregex = helpers.regex('nikregex', /^[0-9]{16}$|^$/i);

export default {
  data: () => ({
    organisasis: [],
    successCreate: null,
    errorMessage:"",
    errorMessageEmail: false,
    errorMessageNik: false,
    errorMessageTtd:"",
    errorMessageParaf:"",
    filettdimg: null,
    fileparafimg: null,
    titledialog:"",
    dialog:false,
    dialogdel: false,
    dialogttd: false,
    dialogparaf: false,
    snackbar: false,
    snackbarText: "",
    snackbarColor: "",
    filedelete: "",
    formData: {
      id:"",
      nama_lengkap:"",
      username:"",
      file_ttd:"",
      file_paraf:"",
      jabatan:"",
      nik:"",
      email:"",
      status: true,
      organisasi:"",
      sumber:"",
      file1:null,
      file2:null,
    },
  }),
  validations: {
    formData: {
      nama_lengkap: {
        required,
        textregex,
        minLength: minLength(3),
        maxLength: maxLength(255)
      },
      email: {
        required,
        emailregex,
        minLength: minLength(3),
        maxLength: maxLength(255)
      },
      organisasi: {
        required,
        textregex,
      },
      nik: {
        nikregex
      },
      jabatan: {
        textregex
      },
      sumber: {
        required
      }
    }
  },
  computed: {
    filteredOrganisasi(){
        return this.organisasis.filter(item => item.status)
    },
    namalengkapErrors() {
      const errors = [];
      if (!this.$v.formData.nama_lengkap.$dirty) return errors;
      !this.$v.formData.nama_lengkap.required &&
      errors.push("Nama Lengkap harus diisi");
      !this.$v.formData.nama_lengkap.minLength &&
      errors.push("Nama Lengkap minimal 3 karakter");
      !this.$v.formData.nama_lengkap.maxLength &&
      errors.push("Nama Lengkap maksimal 255 karakter");
      !this.$v.formData.nama_lengkap.textregex &&
      errors.push("Nama Lengkap hanya boleh mengandung huruf, angka, spasi, dan tanda . , ' ( ) & / -");
      
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.formData.email.$dirty) return errors;
      !this.$v.formData.email.required &&
      errors.push("Email harus diisi");
      !this.$v.formData.email.maxLength &&
      errors.push("Email maksimal 255 karakter");
      !this.$v.formData.email.emailregex &&
      errors.push("Format Email belum sesuai. Contoh: pusilkom@pusilkom.com");
      
      return errors;
    },
    nikErrors() {
      const errors = [];
      if (!this.$v.formData.nik.$dirty) return errors;
      !this.$v.formData.nik.nikregex &&
      errors.push("Nik hanya boleh mengandung angka sebanyak 16 digit");
      
      return errors;
    },
    organisasiErrors() {
      const errors = [];
      if (!this.$v.formData.organisasi.$dirty) return errors;
      !this.$v.formData.organisasi.required &&
      errors.push("Organisasi Pengguna harus dipilih");
      
      return errors;
    },
    jabatanErrors() {
      const errors = [];
      if (!this.$v.formData.jabatan.$dirty) return errors;
      !this.$v.formData.jabatan.textregex &&
      errors.push("Jabatan hanya boleh mengandung huruf, angka, spasi, dan tanda . , ' ( ) & / -");
      
      return errors;
    },
    sumberErrors() {
      const errors = [];
      if (!this.$v.formData.sumber.$dirty) return errors;
      !this.$v.formData.sumber.required &&
      errors.push("Sumber Pengguna harus dipilih");
      
      return errors;
    }
  },
  mounted() {
    console.log("loading")
    this.getData();
    this.getOrganisasi();
    this.fetchImages();
  },
  methods: {
    getData() {
      console.log("get data " + this.$route.params.id)
      apiServer
        .get("/pengguna/detail/id/" + this.$route.params.id)
        .then(response => {
          console.log(response.data.data)
          this.formData = response.data.data.pengguna;
          this.formData.organisasi = response.data.data.pengguna.id_organisasi;
          console.log(this.formData)
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
        });
    },
    postData() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.errorMessageEmail = false
      this.errorMessageNik = false
      let updateData = new FormData()
      updateData.append("Id",this.formData.id)
      updateData.append("NamaLengkap",this.formData.nama_lengkap.trim(" "))
      updateData.append("Username",this.formData.username.trim(" "))
      updateData.append("Jabatan",this.formData.jabatan.trim(" "))
      updateData.append("Nik",this.formData.nik)
      updateData.append("Email",this.formData.email.trim(" "))
      updateData.append("IdOrganisasi",this.formData.organisasi)
      updateData.append("Sumber",this.formData.sumber.trim(" "))
      updateData.append("Status",this.formData.status)
      updateData.append("FileTtd","")
      updateData.append("FileParaf","")
      if(this.formData.file1 != null) {
        updateData.set("FileTtd","filettd")
        updateData.append("file1",this.formData.file1)
        this.errorMessageTtd = ""
      } else {
        if (this.formData.file_ttd === '') {
          this.errorMessageTtd = "File Tanda Tangan harus diisi dengan file PNG"
        }
      }
      if(this.formData.file2 != null) {
        updateData.set("FileParaf","fileparaf")
        updateData.append("file2",this.formData.file2)
        this.errorMessageParaf = ""
      } else {
        if (this.formData.file_paraf === '') {
          this.errorMessageParaf = "File Paraf harus diisi dengan file PNG"
        }
      }
      if(this.errorMessageTtd != "" || this.errorMessageParaf != "") {
        return
      }
      console.log("update pengguna")
      console.log(updateData)
      apiServer
          .post("/pengguna/update",updateData)
          .then(response => {
            console.log("Successfully updated pengguna:")
            console.log(response.data.data)
            localStorage.setItem('updateSuccess', "Pengguna " + this.formData.username + " berhasil diubah.")
            this.$router.push("/pengguna")})
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            if (error.response.data.message.includes("Email")) {
              this.errorMessage = error.response.data.message
              this.errorMessageEmail = true
            } else if (error.response.data.message.includes("NIK")) {
              this.errorMessage = error.response.data.message
              this.errorMessageNik = true
            } else {
              this.showSnackbar("error", error.response.data.message)
            }
          });
    },
    getOrganisasi() {
      this.isLoading = true;
      apiServer
          .get("/organisasi/all")
          .then(response => {
            this.organisasis = response.data.data;
            console.log("search organisasi loaded")
            console.log(this.organisasis)
          })
          .catch(error => {
            console.log("There was an error:", error.response); // Logs out the error
            this.isLoading = false;
          });
    },
    fetchImages() {
      console.log("fetch pengguna images")
      var timestamp = new Date().getTime() // get current timestamp
      apiServer
        .get("/pengguna/id/" + this.$route.params.id + "/getfilettd?timestamp="  + timestamp ,{ responseType: 'blob' })
        .then(response => {
          this.filettdimg = URL.createObjectURL(response.data)
        })
      apiServer
        .get("/pengguna/id/" + this.$route.params.id + "/getfileparaf?timestamp="  + timestamp ,{ responseType: 'blob' })
        .then(response => {
          this.fileparafimg = URL.createObjectURL(response.data)
        })
    },
    showFileTtd() {
      this.close()
      // this.fetchImages()
      console.log("show image " +this.formData.file_ttd)        
      this.dialogttd = true;
      this.titledialog = "File Tanda Tangan";
      this.dialog = true;
    },
    showFileParaf() {
      this.close()
      // this.fetchImages()
      console.log("show image " +this.formData.file_paraf)        
      this.dialogparaf = true;
      this.titledialog = "File Paraf";
      this.dialog = true;
    },    
    deleteDialog(val){
      console.log("delete file" + val )
      this.filedelete = val
      this.dialogdel = true
    },
    deleteFile(){
      if (this.filedelete == "Tanda Tangan") {
        this.deleteFileTtd()
      }
      if (this.filedelete == "Paraf") {
        this.deleteFileParaf()
      }
    },
    deleteFileTtd(){
      apiServer
        .delete("/pengguna/id/"+this.$route.params.id+"/delfilettd")
        .then(response => {
            this.showSnackbar("orange","File Tanda Tangan asli berhasil dihapus")
            this.close()
            this.getData()
          })
        .catch(error => {
            console.log("There was an error:", error); // Logs out the error
            this.getData()
            this.close()
          });
    },
    deleteFileParaf(){
      apiServer
        .delete("/pengguna/id/"+this.$route.params.id+"/delfileparaf")
        .then(response => {
            this.showSnackbar("orange","File Paraf asli berhasil dihapus")
            this.close()
            this.getData()
          })
        .catch(error => {
            console.log("There was an error:", error); // Logs out the error
            this.getData()
            this.close()
          });
    },
    close() {
      this.dialog = false;
      this.titledialog = "";
      this.dialogdel = false;
      this.dialogttd = false;
      this.dialogparaf = false;
    },
    cancel() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      if (this.formData.file_ttd === '') {
        this.errorMessageTtd = "File Tanda Tangan harus diisi dengan file PNG"
      }
      if (this.formData.file_paraf === '') {
        this.errorMessageParaf = "File Paraf harus diisi dengan file PNG"
      }
      if(this.errorMessageTtd != "" || this.errorMessageParaf != "") {
        return
      }
      this.$router.push('/pengguna')
    },
    showSnackbar(color, message) {
        console.log("snack " + color + " - " + message);
        this.snackbar = true;
        this.snackbarText = message;
        this.snackbarColor = color;
    },
    showMessage () {
      this.showSnackbar(
          this.$store.state.snackbar.snackbarColor,
          this.$store.state.snackbar.snackbarText
      )
      this.$store.dispatch('setSnackbar', {
        snackbarColor: null,
        snackbarText: null,
      })
    },
  }
}
</script>
